import { render } from "./ProjectGallery.vue?vue&type=template&id=33968d7b&scoped=true&ts=true"
import script from "./ProjectGallery.ts?vue&type=script&lang=ts"
export * from "./ProjectGallery.ts?vue&type=script&lang=ts"

import "./ProjectGallery.scss?vue&type=style&index=0&id=33968d7b&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33968d7b"]])

export default __exports__